
// when needed use loadjs from assets script
import loadjs from 'loadjs';
/*
 uses: https://github.com/muicss/loadjs
 */
class ResourceLoader {

    static load(resources, id, options = {
        async: true,  // load files synchronously or asynchronously (default: true)
    }) {

        options.returnPromise = true;  // return Promise object (default: false)
        // define a dependency bundle with advanced options
        return loadjs(resources, id, options);

        /*
        promise sample:

        ResourceLoader.load(['/path/to/foo.js', '/path/to/bar.js'])
        .then(function() { loaded })
        .catch(function(pathsNotFound) { at least one didn't load  });
         */
    }

    // array of resource bundle Ids
    static isReady(ids){

        if(!Array.isArray(ids)){
            ids = [ ids ];
        }

        // resolve promise when ready callback is invoked
        return new Promise((resolve, reject) => {

            loadjs.ready(ids, () => {
                resolve(ids);
            });
        });

    }

    static isDefined(id){
        return loadjs.isDefined(id);
    }

    static loadOnce(resources, id, options = {
        async: true,  // load files synchronously or asynchronously (default: true)
    }) {

        // only load once
        if(!ResourceLoader.isDefined(id)){

            return ResourceLoader.load(resources, id, options);

        } else {
            return ResourceLoader.isReady(id);
        }
    }
}

export default ResourceLoader;